import { render, staticRenderFns } from "./PanneDeclarationFormulaire.vue?vue&type=template&id=0cd23288&scoped=true&"
import script from "./PanneDeclarationFormulaire.vue?vue&type=script&lang=js&"
export * from "./PanneDeclarationFormulaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd23288",
  null
  
)

export default component.exports